import { Helmet } from 'react-helmet-async';
import { useParams, Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { blogApi } from '../lib/api';
import ReactMarkdown from 'react-markdown';

export function BlogPostPage() {
  const { slug } = useParams<{ slug: string }>();
  const { data: post, isLoading } = useQuery({
    queryKey: ['blog-post', slug],
    queryFn: () => blogApi.getBySlug(slug!).then((res) => res.data),
    enabled: !!slug,
  });

  if (isLoading) {
    return <div className="container-custom py-12 text-center">Yükleniyor...</div>;
  }

  if (!post) {
    return (
      <div className="container-custom py-12 text-center">
        <h1 className="text-2xl font-bold mb-4">Yazı bulunamadı</h1>
        <Link to="/blog" className="btn btn-primary">
          Blog Sayfasına Dön
        </Link>
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>{post.title} - {import.meta.env.VITE_APP_NAME || 'KUMBİLGİ'} Blog</title>
        <meta name="description" content={post.excerpt || post.title} />
      </Helmet>

      <div className="container-custom py-12">
        <nav className="mb-6 text-sm text-gray-600">
          <Link to="/" className="hover:text-primary-600">Ana Sayfa</Link>
          {' / '}
          <Link to="/blog" className="hover:text-primary-600">Blog</Link>
          {' / '}
          <span className="text-gray-900">{post.title}</span>
        </nav>

        <article className="max-w-4xl mx-auto">
          {post.coverImage && (
            <img
              src={post.coverImage}
              alt={post.title}
              className="w-full h-96 object-cover rounded-lg mb-8"
            />
          )}

          <h1 className="text-4xl font-bold mb-4">{post.title}</h1>
          {post.excerpt && (
            <p className="text-xl text-gray-600 mb-8">{post.excerpt}</p>
          )}

          <div className="prose max-w-none">
            <ReactMarkdown>{post.content}</ReactMarkdown>
          </div>

          {post.author && (
            <div className="mt-8 pt-8 border-t border-gray-200">
              <p className="text-gray-600">
                <strong>Yazar:</strong> {post.author.name || post.author.email}
              </p>
              {post.publishedAt && (
                <p className="text-gray-600">
                  <strong>Yayın Tarihi:</strong>{' '}
                  {new Date(post.publishedAt).toLocaleDateString('tr-TR')}
                </p>
              )}
            </div>
          )}
        </article>
      </div>
    </>
  );
}

